import { useSelector } from 'react-redux';

// Define the state interface
interface RootState {
  privileges: {
    privileges: string[] | string;
  };
}

type PrivilegeChecker = (privilege: string) => boolean;

const usePrivilege: PrivilegeChecker = (privilege) => {
  const privilegesData = useSelector((state: RootState) => {
    // Safely access nested privileges
    const privileges = state?.privileges?.privileges;
    
    return privileges;
  });
  
  // If privileges is a string, return true
  if (typeof privilegesData === 'string' && privilegesData === 'superadmin' ) {
    return true;
  }
  
  // If privileges is an array, perform the check with additional safeguards
  const privilegesArray = privilegesData || [];
  const hasPrivilege = Array.isArray(privilegesArray) && 
    privilegesArray.length > 0 && 
    privilegesArray.includes(privilege);
  
  return hasPrivilege;
};

export default usePrivilege;